export const SET_EXPEDIENT = (state, value) => {
  state.expedient = value
}

export const SET_DESCRIPTION = (state, value) => {
  state.description = value
}

export const SET_AMOUNT = (state, value) => {
  state.amount = value
}
